import { NgxSliderModule, Options } from '@angular-slider/ngx-slider';
import { DOCUMENT, NgFor, NgIf, TitleCasePipe, isPlatformBrowser } from '@angular/common';
import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  ViewChild
} from '@angular/core';
import {
  ToastrService
} from 'ngx-toastr';
import {
  Observable,
  lastValueFrom
} from 'rxjs';
import {
  Zone,
  ZoneService
} from 'src/app/api';
import {
  AppComponent
} from 'src/app/app.component';
import {
  AuthenticationService
} from 'src/app/services/authentication.service';
import { ConsoleLoggerService } from 'src/app/services/console-logger.service';
import {
  LegacyServicesService
} from 'src/app/services/legacy-services.service';
import { LocationServiceService } from 'src/app/services/location-service.service';
import {
  environment
} from 'src/environments/environment';
import {
  CommonComponent
} from '../../common/common.component';
import { LoadingComponent } from '../loading/loading.component';

export interface ReturnEvent {
  metodo: number;
  results?: any;
  placeholder?: string;
}

@Component({
  selector: 'app-search-bar-map',
  templateUrl: './search-bar-map.component.html',
  styleUrls: ['./search-bar-map.component.scss'],
  standalone: true,
  imports: [NgIf, NgxSliderModule, NgFor, LoadingComponent, TitleCasePipe]
})
export class SearchBarMapComponent
  extends CommonComponent
  implements OnInit, AfterViewChecked, OnDestroy {
  // GESTIONE DELLA RICERCA
  public searchListSuggestions: any;
  public searchLoading = false;
  public searchMarker: any;
  public searchTimer: any;
  public idPolygonSearched: string;

  // GESTIONE DELLA MAPPA
  public L = this.legacyService.getL();
  public map: any;
  public shownLayers: any;
  public mapLoading = false;

  public metodo: number; // METODO DI RICERCA TRAMITE MAPPA
  public placeholder = '';
  public selectedFeatures: any = []; // CONTIENE LE INFORMAZIONI DELLE ZONE GEOGRAFICHE DA USARE NELLE RICERCHE

  // METODO 2
  public comune = '';
  public timerChangeRadius: any;
  userLocationFail: string;
  untouched = true;

  // METODO 3
  public mapViewType = 'provinces';
  public centerMap: any = {
    lat: 0,
    lng: 0
  };
  public zoomMap = 10;
  public zoomSwitchZone = 11;
  public municipalities: Zone[] = [];

  // METODO 4
  public drawPolygon: any;
  mobile = false;
  group: any;
  isFreeHandEditing = false;
  hasFinishedFreeHandEditing = false;
  searchMarkersFeaturesGroup: any;
  hasSearchedAddress = false;

  // RANGE SLIDER
  showRange = false;
  rangeValue = 0;
  circle: any;
  rangeOptions: Options = {
    floor: 0.2,
    ceil: 15,
    step: 0.1,
    vertical: true,
    hideLimitLabels: true,
    translate: (value: number): string => {
      return `${value} km`;
    }
  };

  // Bug prevention
  showMap = true;

  // Delete button
  deleteButton: any;
  deleteLayer: any;

  boxMapHeight: number;

  // City zones
  isCityWithZone = false;
  cityPerimeter: any;
  showMobileCityList = false;
  showCityZones = true;


  constructor(
    @Inject(PLATFORM_ID) private platform: any,
    private zones: ZoneService,
    private legacyService: LegacyServicesService,
    private main: AppComponent,
    public authenticationService: AuthenticationService,
    private toastr: ToastrService,
    private locationService: LocationServiceService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private console: ConsoleLoggerService
  ) {
    super(authenticationService);
  }
  @Input() openMapEvents: Observable<number>;
  @Input() citySelected: any;
  @Output() closeEvent = new EventEmitter<ReturnEvent | null>();
  @Output() changeEvent = new EventEmitter<number>();
  @ViewChild('boxMap') boxMap: ElementRef;
  @ViewChild('map') mapHtml: ElementRef;

  async ngOnInit(): Promise<void> {
    if (this.citySelected) {
      this.isCityWithZone = true;
    }
    await this.initFunction();
    this.extendLCircle();
    this.document.documentElement.style.overflow = 'hidden';
    if (this.citySelected) {
      this.clickSearchItem(this.citySelected);
      this.addCityPerimeterToMap();
    }
  }

  ngOnDestroy(): void {
    this.document.documentElement.style.overflow = 'unset';
    this.document.documentElement.scrollTo(0, 0);
  }

  async initFunction(hasChangedMethod?: boolean): Promise<void> {
    this.mobile = window.screen.width < 768;
    // CHIEDO I CONTORNI DELLE PROVINCE E REGIONI
    await this.getProvinces();
    this.openMapEvents.subscribe(async (metodo) => {
      // RESETTA LE VARIABILI PRIMA DI AVVIARE LA MAPPA
      if (this.map) {
        this.resetSelection();
      }

      if (!hasChangedMethod) {
        this.metodo = metodo;
      }
      // INIZIALIZZA LA MAPPA
      if (isPlatformBrowser(this.platform) && !this.map) {
        this.initMap();
      }

      if (this.map && !this.citySelected) { this.map.setView([42.5, 10.9], 6.9); }
      if (this.shownLayers) { this.shownLayers.clearLayers(); }

      // IN BASE ALLA TIPOLOGIA DI RICERCA
      switch (this.metodo) {
        // METODO 2 - SELEZIONA PUNTO
        case 2:
          this.untouched = true;
          setTimeout(() => {
            this.locationService.getPosition().then(location => {
              this.clickAction({ latlng: location }, true);
            }).catch(e => {
              this.userLocationFail = e;
            });
          }, 100);
          break;
        // METODO 3 - SELEZIONA ZONA
        case 3:
          this.addPolygonsToMap(this.main.provincesMap);
          this.map.addLayer(this.shownLayers);
          break;
        // METODO 4 - DISEGNA AREA
        case 4:
          if (!this.mobile) {
            this.drawPolygon = new this.L.Draw.Polygon(this.map);
            const originalOnTouch = this.L.Draw.Polygon.prototype._onTouch;
            this.L.Draw.Polygon.prototype._onTouch = function(e: any): void {
              if (e.originalEvent.pointerType !== 'mouse') {
                return originalOnTouch.call(this, e);
              }
            };
            this.drawPolygon.enable();
          } else {
            this.setFreeHandsEditing();
          }
          break;
      }
    });
  }

  ngAfterViewChecked(): void {
    // if (this.map) {
    //   this.map.invalidateSize(true);
    // }
    if (this.mobile) {
      this.boxMapHeight = this.boxMap.nativeElement.offsetHeight;
      const height = `calc(${window.innerHeight - this.boxMapHeight}px)`;
      if (this.mapHtml) {
        this.renderer.setStyle(this.mapHtml.nativeElement, 'height', height);
      }
    }
  }

  // CHIUDI LE MAPPE SENZA INFORMAZIONI
  close(): void {
    this.closeEvent.emit(null);
    this.resetSelection();
  }

  // CHIUDI LE MAPPE E AVVIA RICERCA
  closeWithResults(): void {
    if (this.metodo === 2) { this.placeholder += ' (Area vicino a te)'; }
    if (this.metodo === 4) { this.placeholder += ' (Area disegnata)'; }
    const object: ReturnEvent = {
      metodo: this.metodo,
      results: this.selectedFeatures,
      placeholder: this.placeholder,
    };
    this.closeEvent.emit(object);
    this.resetSelection();
  }

  // INIZIALIZZA LA MAPPA
  private initMap(): void {
    const that = this;
    const center = [42.5, 10.9];
    try {
      this.map = this.L.map('searchBarMap', {
        center,
        zoom: 6,
        dragging: true,
        maxZoom: 18,
        tap: false,
        preferCanvas: true
      });
      const tiles = this.L.tileLayer(
        `https://api.mapbox.com/styles/v1/cercacasa/ckpe5qu6v0hd118p6w3tdkjp1/tiles/{z}/{x}/{y}?access_token=${environment.mapAccessToken}`, {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }
      );
      tiles.addTo(this.map);
      this.console.info('INIT MAP SEARCH-BAR-MAP');
      this.addGestureToMap();
    } catch (error) {
      this.console.error('Errore Mappa');
    }
  }

  // RESETTA LA SELEZIONE
  resetSelection(resetResponse = false): void {
    this.destroyDeleteButton();
    this.showRange = false;
    if (document.getElementById('search-address-input')) {
      (document.getElementById('search-address-input') as HTMLInputElement).value = '';
    }
    this.idPolygonSearched = null;
    if (this.searchMarker) { this.map.removeLayer(this.searchMarker); }
    this.searchListSuggestions = null;
    this.selectedFeatures = [];
    if (this.shownLayers) { this.shownLayers.clearLayers(); }
    if (this.metodo === 3) { this.redrawPolygons(); }

    if (this.metodo === 4 && !resetResponse && this.drawPolygon) {
      if (this.drawPolygon.disable) {
        this.drawPolygon.disable();
      }
    }
    if (this.metodo === 4 && resetResponse && this.map) {
      if (!this.mobile) {
        this.drawPolygon = new this.L.Draw.Polygon(this.map);
        this.drawPolygon.enable();
      } else {
        this.isFreeHandEditing = false;
        this.hasFinishedFreeHandEditing = false;
        this.setFreeHandsEditing();
      }
    }
    if (this.map) {
      this.clickOnMap();
    }
  }

  // AGGIUNGE LE GESTURE ALLA MAPPA
  addGestureToMap(): void {
    // METODO 3 - MOSTRA I CONFINI DELLE PROVINCE O DEI COMUNI
    if (this.metodo === 3) {
      this.map.on('moveend', (e) => {
        this.zoomMap = this.map.getZoom();

        // CONTROLLO SE SI SPOSTA TANTO SULLA MAPPA PER POTER RICARICARE LA MAPPA DEI COMUNI
        const lat = Math.round(
          Math.abs(this.centerMap.lat - this.map.getBounds().getCenter().lat) *
          10
        );
        const lng = Math.round(
          Math.abs(this.centerMap.lng - this.map.getBounds().getCenter().lng) *
          10
        );
        let value = this.zoomMap;
        let sum = 0;
        while (value) {
          sum += value % 10;
          value = Math.floor(value / 10);
        }

        if (this.zoomMap >= this.zoomSwitchZone && (lat > sum || lng > sum)) {
          this.centerMap = this.map.getBounds().getCenter();
          this.loadMunicipalitiesWithCenter(this.centerMap);
        }
      });
    }

    // METODO 2 - CLICK SULLA MAPPA
    this.clickOnMap();

    // METODO 2 - MODIFICA IL RAGGIO DELLA RICERCA
    if (this.metodo === 2) {
      this.map.on(this.L.Draw.Event.EDITRESIZE, (e) => {
        const layer = e.layer;
        const geoJson = layer.toGeoJSON();
        this.selectedFeatures = [];
        geoJson.properties.radius = layer.getRadius();
        this.rangeValue = layer.getRadius() / 1000;
        this.selectedFeatures.push(geoJson);
        this.placeholder =
          this.showKm(this.selectedFeatures[0].properties.radius) +
          ' km da ' +
          this.comune;
      });
    }

    // METODO 2 - MODIFICA LA POSIZIONE DEL RAGGIO DI RICERCA
    if (this.metodo === 2) {
      const that = this;
      this.map.on(this.L.Draw.Event.EDITMOVE, (e) => {
        that.destroyDeleteButton();
        const layer = e.layer;
        const geoJson = layer.toGeoJSON();
        this.console.log('edit started');
        this.selectedFeatures = [];
        geoJson.properties.radius = layer.getRadius();
        this.rangeValue = layer.getRadius() / 1000;
        const t = this;
        this.mapLoading = true;
        this.createDeleteButton(layer._latlng, layer._radius, 'circle');
        t.zones.zoneGeocode(layer._latlng.lat, layer._latlng.lng).subscribe(
          (success) => {
            t.selectedFeatures.push(geoJson);
            t.mapLoading = false;
            try {
              t.comune = 'Zona non indetificata';
              success.features.forEach((item) => {
                if (item.id.toString().indexOf('region.') !== -1) {
                  t.selectedFeatures[0].properties.prov_name = item.text;
                }
                if (item.id.toString().indexOf('place.') !== -1) {
                  t.comune = item.text;
                  t.selectedFeatures[0].properties.name = item.text;
                }
              });
            } catch (e) {
              this.console.error(e);
              t.comune = 'Zona non indetificata';
            }
            t.placeholder =
              t.showKm(t.selectedFeatures[0].properties.radius) +
              ' km da ' +
              t.comune;
          },
          (error) => {
            t.mapLoading = false;
          }
        );
      });
    }

    // METODO 3 - MOSTRA I CONFINI DELLE PROVINCE O DEI COMUNI
    if (this.metodo === 3) {
      this.map.on('zoomend', (e) => {
        this.zoomMap = this.map.getZoom();
        this.console.log(this.zoomMap);

        if (
          this.zoomMap >= this.zoomSwitchZone &&
          this.mapViewType === 'provinces'
        ) {
          this.selectedFeatures = [];
          this.mapViewType = 'zones';
          this.console.log('switch to zones');
          this.loadMunicipalitiesWithCenter(this.map.getBounds().getCenter());
        } else if (
          this.zoomMap < this.zoomSwitchZone &&
          this.mapViewType === 'zones'
        ) {
          this.selectedFeatures = [];
          this.mapViewType = 'provinces';
          this.console.log('switch to provinces');
          this.redrawPolygons();
        } else if (this.searchMarker != null) {
          this.redrawPolygons();
        }
      });
    }

    // METODO 4 - QUANDO DISEGNO UN VERTICE
    if (this.metodo === 4 && !this.mobile) {
      this.map.on(this.L.Draw.Event.DRAWVERTEX, (e: any) => {
        this.drawPolygon._markers[0]._icon.classList.add('firstIcon');
      });
    }

    // METODO 4 - QUANDO VIENE CREATA LA SAGOMA
    if (this.metodo === 4) {
      this.map.on(this.L.Draw.Event.CREATED, (e) => {
        this.console.log('CREATED', e);
        this.drawPolygon._markers[0]._icon.classList.remove('firstIcon');
        this.resetSelection();
        const layer = e.layer;
        const deletePoint = this.findQuarterLatLng(layer.editing.latlngs[0][0][0], layer.editing.latlngs[0][0][1]);
        this.createDeleteButton(deletePoint, null, 'point');
        const geoJson = layer.toGeoJSON();
        if (!this.shownLayers) {
          this.shownLayers = new this.L.FeatureGroup();
        }
        this.shownLayers.addLayer(layer);
        this.selectedFeatures.push(geoJson);
        this.map.addLayer(this.shownLayers);
        layer.editing.enable();

        this.mapLoading = true;
        this.zones
          .zoneGeocode(
            layer.getBounds().getCenter().lat,
            layer.getBounds().getCenter().lng
          )
          .subscribe(
            (success) => {
              try {
                this.mapLoading = false;
                this.comune = 'Zona non indetificata';
                success.features.forEach((item) => {
                  if (item.id.toString().indexOf('region.') !== -1) {
                    this.selectedFeatures[0].properties.prov_name =
                      item.text;
                  }
                  if (item.id.toString().indexOf('place.') !== -1) {
                    this.comune = item.text;
                    this.selectedFeatures[0].properties.name = item.text;
                  }
                });
              } catch (e) {
                this.mapLoading = false;
                this.comune = 'Zona non indetificata';
              }
              this.placeholder = this.comune;
              this.drawPolygon.disable();
            },
            (error) => {
              this.mapLoading = false;
            }
          );
      });
    }

    // METODO 4 - QUANDO VENGONO MODIFICATI I PUNTI DELLA SAGOMA
    if (this.metodo === 4) {
      this.map.on(this.L.Draw.Event.EDITVERTEX, (e) => {
        this.console.log('EDITVERTEX', e);
        const layer = e.poly;
        const geoJson = layer.toGeoJSON();
        this.selectedFeatures = [];
        this.selectedFeatures.push(geoJson);
        this.mapLoading = true;
        this.destroyDeleteButton();
        const deletePoint = this.findQuarterLatLng(layer.editing.latlngs[0][0][0], layer.editing.latlngs[0][0][1]);
        this.createDeleteButton(deletePoint, null, 'point');
        this.zones
          .zoneGeocode(
            layer.getBounds().getCenter().lat,
            layer.getBounds().getCenter().lng
          )
          .subscribe(
            (success) => {
              try {
                this.mapLoading = false;
                success.features.forEach((item) => {
                  if (item.id.toString().indexOf('region.') !== -1) {
                    this.selectedFeatures[0].properties.prov_name =
                      item.text;
                  }
                  if (item.id.toString().indexOf('place.') !== -1) {
                    this.comune = item.text;
                    this.selectedFeatures[0].properties.name = item.text;
                  }
                });
              } catch (e) {
                this.mapLoading = false;
                this.comune = 'Zona non indetificata';
              }
              this.placeholder = this.comune;
            },
            (error) => {
              this.mapLoading = false;
            }
          );
      });
    }

  }

  // METODO 3 - CARICA I COMUNI IN BASE AL CENTRO DELLA MAPPA
  private async loadMunicipalitiesWithCenter(center: any): Promise<void> {
    const filterComune = {
      where: {
        and: [{
          or: [{
            type: 'Comune'
          }, {
            type: 'Zona'
          }]
        },
        {
          geometry: {
            nearSphere: {
              $geometry: {
                type: 'Point',
                coordinates: [center.lng, center.lat],
              },
              $maxDistance: 50000,
              $minDistance: 0,
            },
          },
        },
        ],
      }
    };
    this.mapLoading = true;
    this.municipalities = await lastValueFrom(this.zones
      .zoneFind(JSON.stringify(filterComune)));
    this.mapLoading = false;
    this.municipalities.forEach((mun: any) => {
      if (mun.name) { mun.properties.name = mun.name; }
      if (mun.id) { mun.properties.id = mun.id; }
      if (mun.type !== 'Feature') { mun.properties.type = mun.type; }

      mun.type = 'Feature';
      if (
        this.municipalities.findIndex(
          (m) => m.properties.op_id === mun.properties.op_id
        ) === -1
      ) {
        this.municipalities.push(mun);
      }
    });
    this.redrawPolygons();
  }

  // METODO 3 - CONTROLLA SE CON LO ZOOM SI PASSA DA PROVINCE A COMUNI
  private redrawPolygons(): void {
    if (this.mapViewType === 'zones') {
      this.addPolygonsToMap(this.municipalities);
    } else {
      this.addPolygonsToMap(this.main.provincesMap);
      this.citySelected = undefined;
      this.isCityWithZone = undefined;
      if (this.cityPerimeter) {
        this.cityPerimeter.clearLayers();
      }
    }
  }

  // METODO 3 - DISEGNA LE ZONE PROVINCE/COMUNI E LE RENDE SELEZIONABILI
  private addPolygonsToMap(polygons: any): void {
    this.console.log('DRAW POLYGONS');
    if (!this.shownLayers) {
      this.shownLayers = new this.L.FeatureGroup();
    }
    const p = [];
    polygons.forEach((poly) => {
      if (poly.name) { poly.properties.name = poly.name; }
      if (poly.id) { poly.properties.id = poly.id; }
      if (poly.type !== 'Feature') { poly.properties.type = poly.type; }
      poly.type = 'Feature';
      const obj = this.selectedFeatures.filter((item) => item.id === poly.id);
      const polygon = this.L.geoJSON(poly, {
        color: '#166FC1',
        weight: 1.5,
        opacity: 1,
        fillOpacity: obj.length > 0 || this.idPolygonSearched === poly.id ? 0.4 : 0,
        lineCap: 'round',
        linejoin: 'round',
        fillColor: '#166FC1',
        fillRule: 'evenodd',
        interactive: true,
      });
      if (!this.mobile && poly.properties.type === 'Zona') {
        polygon.bindTooltip((poly.display_name + ` (${poly.properties.comune_name})`), {
          permanent: false,
          direction: 'center',
        });
      }
      if (!this.mobile && poly.properties.type !== 'Zona') {
        polygon.bindTooltip(poly.properties.name, {
          permanent: false,
          direction: 'center',
        });
      }
      polygon.on({
        mouseover: (e) => {
          e.target.setStyle({
            fillOpacity: 0.3,
          });
        },
        mouseout: (e) => {
          polygon.resetStyle(e.layer);
        },
        click: (e) => {
          this.clickOnPolygon(e.layer.feature, polygon, e.layer);
          this.redrawPolygons();
        },
        touch: (e) => {
          this.console.log(e);

        }
      });
      if (this.idPolygonSearched === poly.id) {
        let elementLayer: any;
        for (const [key, value] of Object.entries(polygon._layers)) {
          elementLayer = value;
        }
        this.clickOnPolygon(poly, polygon, elementLayer._layer);
        this.idPolygonSearched = null;
      }
      p.push(polygon);
    });
    this.shownLayers.clearLayers();
    p.forEach((item) => {
      this.shownLayers.addLayer(item);
    });
  }

  // METODO 3 - EVENTO DI CLICK SULLA PROVINCIA, COMUNE O ZONA
  async clickOnPolygon(feature, polygon, layer): Promise<void> {
    if (feature.properties.type === 'Zona' && (!this.citySelected)) {
      const filterComune = {
        where: {
          and: [
            {
              type: 'Comune'
            },
            {
              name: feature.properties.comune_name
            }
          ],
        },
        include: ['children']
      };
      this.mapLoading = true;
      try {
        const city = await lastValueFrom(this.zones
          .zoneFind(JSON.stringify(filterComune)));
        this.citySelected = city[0];
        this.isCityWithZone = true;
        this.showCityZones = true;
        this.addCityPerimeterToMap();
      }
      catch (e) {
        this.console.log(e);
      }
      this.mapLoading = false;
      const toRemove = this.selectedFeatures.findIndex(a => a.name === this.citySelected.name);
      if (toRemove > -1) {
        this.selectedFeatures.splice(toRemove, 1);
        polygon.resetStyle(this.selectedFeatures[toRemove]);
      }
    } else {
      const prevCitySelected = this.citySelected;

      if ((this.citySelected && feature && feature.properties.comune_name !== this.citySelected.name) || feature.properties.type === 'Provincia') {
        this.citySelected = undefined;
        this.isCityWithZone = undefined;
        if (this.cityPerimeter) {
          this.cityPerimeter.clearLayers();
        }
      }

      if (this.isCityWithZone && feature.properties.comune_name === this.citySelected.name) {
        if (this.checkNoZoneSelected()) {
          this.resetSelection();
        }
      }

      if (feature.properties.type === 'Zona') {
        this.isCityWithZone = true;
        this.citySelected = prevCitySelected;
      }

      if (this.isCityWithZone && feature.properties.type === 'Zona' && (feature.properties.comune_name !== this.citySelected.name)) {
        const filterComune = {
          where: {
            and: [
              {
                type: 'Comune'
              },
              {
                name: feature.properties.comune_name
              }
            ],
          },
          include: ['children']
        };
        this.mapLoading = true;
        try {
          const city = await lastValueFrom(this.zones
            .zoneFind(JSON.stringify(filterComune)));
          this.citySelected = city[0];
          this.isCityWithZone = true;
          this.addCityPerimeterToMap();
          this.showCityZones = true;
        }
        catch (e) {
          this.console.log(e);
        }
        this.mapLoading = false;
        const toRemove = this.selectedFeatures.findIndex(a => a.name === this.citySelected.name);
        if (toRemove > -1) {
          this.selectedFeatures.splice(toRemove, 1);
          polygon.resetStyle(this.selectedFeatures[toRemove]);
        }
      }
    }


    const indexFeatures = this.selectedFeatures.findIndex(a => a.id === feature.id);
    if (indexFeatures !== -1) {
      this.selectedFeatures.splice(indexFeatures, 1);
      polygon.resetStyle(layer);
      this.redrawPolygons();
    } else {
      this.selectedFeatures.push({
        ...feature,
        polygon,
        layer
      });
    }

    if (this.citySelected) {
      this.redrawPolygons();
    }

    if (this.selectedFeatures.length > 0) {
      this.placeholder = 'Zone selezionate: ';
      const z = [];
      this.selectedFeatures.forEach((element) => {
        z.push(element.properties.name);
      });
      this.placeholder += z.join(', ');
    }
  }

  // METODO 3 - RIMUOVI SELEZIONE
  removePolygon(feature, polygon, layer): void {
    const indexFeatures = this.selectedFeatures.findIndex(a => a.id === feature.id);
    if (indexFeatures !== -1) {
      this.selectedFeatures.splice(indexFeatures, 1);
      polygon.resetStyle(layer);
      this.redrawPolygons();
    }
    this.citySelected = undefined;
    this.isCityWithZone = undefined;
    if (this.cityPerimeter) {
      this.cityPerimeter.clearLayers();
    }
  }

  // METODO 3 - RECUPERA IL GEO JSON DELLE PROVINCE E COMUNI
  private async getProvinces(): Promise<void> {
    if (!this.main.provincesMap || this.main.provincesMap.length === 0) {
      const filter = {
        where: {
          type: 'Provincia',
        },
      };
      this.mapLoading = true;
      this.main.provincesMap = await lastValueFrom(this.zones
        .zoneFind(JSON.stringify(filter)));
      this.mapLoading = false;
    }
  }

  // METODO 2 - VICINO A ME
  showKm(radius: number): string {
    return parseFloat((radius / 1000).toString()).toFixed(2);
  }

  // METODO 2, 3, 4 - RICERCA INDIRIZZO
  searchLocation(value): void {
    clearTimeout(this.searchTimer);
    this.searchListSuggestions = null;
    if (value !== '' && value.length > 2) {
      this.searchLoading = true;
      const id =
        this.currentUser != null && this.currentUser.id != null ?
          this.currentUser.id :
          null;
      this.searchTimer = setTimeout(() => {
        this.zones.zoneSearch(value, id, this.metodo).subscribe(
          (success) => {
            this.searchLoading = false;
            this.searchListSuggestions = success;
          },
          (error) => {
            this.console.error(error);
            this.searchLoading = false;
            this.toastr.error('Si è verificato un errore durante la ricerca.');
          }
        );
      }, 250);
    } else {
      this.searchLoading = false;
      this.searchListSuggestions = null;
    }
  }

  // METODO 2 - CLICK SULLA MAPPA
  clickOnMap(): void {
    if (this.metodo === 2 && this.selectedFeatures.length === 0) {
      this.map.on('click', (e) => {
        this.clickAction(e);
      });
    }
  }

  clickAction(e, isAddress?: boolean): void {
    this.untouched = false;
    this.resetSelection();
    const that = this;
    const latLng = e.latlng;
    let radius: number;
    if (!isAddress) {
      switch (this.map.getZoom()) {
        case 18:
          radius = 200;
          break;
        case 17:
          radius = 200;
          break;
        case 16:
          if (this.mobile) {
            radius = 200;
          } else {
            radius = 600;
          }
          break;
        case 15:
          if (this.mobile) {
            radius = 500;
          } else {
            radius = 1200;
          }
          break;
        case 14:
          if (this.mobile) {
            radius = 1000;
          } else {
            radius = 2700;
          }
          break;
        case 13:
          if (this.mobile) {
            radius = 2100;
          } else {
            radius = 5000;
          }
          break;
        case 12:
          if (this.mobile) {
            radius = 4400;
          } else {
            radius = 10000;
          }
          break;
        default:
          if (this.mobile) {
            radius = 6600;
          } else {
            radius = 15000;
          }
          break;
      }
    } else {
      radius = 1000;
    }
    const circle = this.L.circle(latLng, {
      radius,
      color: '#166FC1',
      fillColor: '#166FC1',
      fillOpacity: 0.3,
    }).on('move', (): void => {
      that.destroyDeleteButton();
    });
    circle.editing.enable();
    const geoJson = circle.toGeoJSON();
    geoJson.properties.radius = circle.getRadius();
    this.selectedFeatures.push(geoJson);
    if (!this.shownLayers) {
      this.shownLayers = new this.L.FeatureGroup();
    }
    this.shownLayers.addLayer(circle);
    this.map.addLayer(this.shownLayers);
    this.createDeleteButton(latLng, circle._radius, 'circle');
    if (!isAddress) {
      if (this.mobile) {
        if (this.map.getZoom() < 11) {
          this.map.setZoom(11, { animate: false });
        }
        this.map.panInsideBounds(circle.getBounds());
      } else {
        if (this.map.getZoom() < 11) {
          this.map.setZoom(11, { animate: false });
        }
        this.map.panInsideBounds(circle.getBounds());
      }
    } else {
      setTimeout(() => {
        this.map.fitBounds(circle.getBounds());
      }, 500);
    }
    this.showRange = true;
    this.rangeValue = circle._mRadius / 1000;
    this.circle = circle;
    this.mapLoading = true;
    this.zones.zoneGeocode(e.latlng.lat, e.latlng.lng).subscribe(
      (success) => {
        this.mapLoading = false;
        try {
          this.comune = 'Zona non indetificata';
          success.features.forEach((item) => {
            if (item.id.toString().indexOf('region.') !== -1) {
              this.selectedFeatures[0].properties.prov_name = item.text;
            }
            if (item.id.toString().indexOf('place.') !== -1) {
              this.comune = item.text;
              this.selectedFeatures[0].properties.name = item.text;
            }
          });
          this.placeholder = `${radius / 1000} km da ` + this.comune;
          this.map.off('click');
        } catch (e) {
          this.console.error(e);
          this.comune = 'Zona non indetificata';
          this.placeholder = this.comune;
        }
      },
      (error) => {
        this.mapLoading = false;
      }
    );
  }

  // CLICK SUI RISULTATI DI RICERCA
  async clickSearchItem(item, fromSuggestion?): Promise<void> {
    if (this.metodo === 3) {
      if (fromSuggestion) {
        this.resetSelection();
        if (item.children && item.children.length) {
          this.showCityZones = true;
          this.isCityWithZone = true;
          this.citySelected = item;
          this.addCityPerimeterToMap();
        } else {
          this.isCityWithZone = false;
          this.citySelected = undefined;
        }
        if (this.cityPerimeter) {
          this.cityPerimeter.clearLayers();
        }
      }
      this.idPolygonSearched = item.id;
      const icon = this.L.divIcon({
        className: '',
        popupAnchor: [0, 0],
      });
      try {
        await this.centerPolygon(item, icon);
      }
      finally {
        this.redrawPolygons();
      }

    } else if (this.metodo === 2) {
      this.clickAction({
        latlng: {
          lat: item.geometry.coordinates[1],
          lng: item.geometry.coordinates[0]
        }
      }, true);
    } else {
      this.hasSearchedAddress = true;
      const icon = new this.L.Icon({
        iconUrl: '../assets/img/marker-icon.svg',
        iconAnchor: [10, 35]
      });
      if (item.type === 'Google') {
        this.searchMarker = this.L.marker(
          [item.geometry.coordinates[1], item.geometry.coordinates[0]], {
          icon,
        }
        );
        const listOfCoordinates = [];
        listOfCoordinates.push(this.searchMarker);
        if (this.searchMarkersFeaturesGroup) {
          this.searchMarkersFeaturesGroup.clearLayers();
        }
        this.searchMarkersFeaturesGroup = this.L.featureGroup(listOfCoordinates).addTo(this.map);
        if (item.properties?.bounds) {
          const bounds = new this.L.LatLngBounds(
            item.properties.bounds.southwest,
            item.properties.bounds.northeast
          );
          this.map.fitBounds(bounds);
        } else {
          this.map.fitBounds(this.searchMarkersFeaturesGroup.getBounds());
        }
      } else {
        this.centerPolygon(item, icon);
      }
      this.clickOnMap();
    }
    this.searchListSuggestions = undefined;
  }

  // PRENDE LE CORDINATE DI UNA: ZONA, COMUNE O PROVINCIA E LE CENTRA
  async centerPolygon(item, icon): Promise<void> {
    const geoJSON = await this.L.geoJson(item.geometry);

    // if (item.type != 'Regione' && item.type != 'Provincia') {
    this.searchMarker = this.L.marker(
      [
        geoJSON.getBounds().getCenter().lat,
        geoJSON.getBounds().getCenter().lng,
      ], {
      icon
    }
    );
    this.map.addLayer(this.searchMarker);
    // }
    this.map.fitBounds(geoJSON.getBounds());
  }

  // METODO 4 MOBILE

  setFreeHandsEditing(): void {
    const that = this;
    this.drawPolygon = new this.L.FreeHandShapes({
      simplify_tolerance: 0,
      polygon: {
        smoothFactor: 1,
      },
      polyline: {
        color: '#67a5e6'
      },
    });
    this.drawPolygon.setMode('view');
    this.group = new this.L.LayerGroup();
    this.group.addLayer(this.drawPolygon);
    this.drawPolygon.on('layeradd', (e: any) => {
      const layer = e.layer;
      that.createDeleteButton(layer.editing.latlngs[0][0][0], null, 'pointMobile');
      const geoJson = layer.toGeoJSON();
      if (!that.shownLayers) {
        that.shownLayers = new that.L.FeatureGroup();
      }
      that.shownLayers.addLayer(layer);
      that.selectedFeatures.push(geoJson);
      that.map.addLayer(that.shownLayers);
      // layer.editing.enable();
      that.drawPolygon.setMode('view');
      that.mapLoading = true;
      that.zones
        .zoneGeocode(
          layer.getBounds().getCenter().lat,
          layer.getBounds().getCenter().lng
        )
        .subscribe(
          (success) => {
            try {
              that.mapLoading = false;
              that.comune = 'Zona non indetificata';
              success.features.forEach((item) => {
                if (item.id.toString().indexOf('region.') !== -1) {
                  that.selectedFeatures[0].properties.prov_name =
                    item.text;
                }
                if (item.id.toString().indexOf('place.') !== -1) {
                  that.comune = item.text;
                  that.selectedFeatures[0].properties.name = item.text;
                }
              });
            } catch (e) {
              that.mapLoading = false;
              that.comune = 'Zona non indetificata';
            }
            that.placeholder = that.comune;
          },
          (error) => {
            that.mapLoading = false;
          }
        );
      that.hasFinishedFreeHandEditing = true;
    });
    this.group.addTo(this.map);
  }

  getSearchLabel(): string {
    if (this.mobile && this.metodo === 4) {
      if (this.isFreeHandEditing && this.hasFinishedFreeHandEditing) {
        return 'Ricerca';
      } else if (this.isFreeHandEditing) {
        return 'Disegna area su mappa';
      } else {
        return 'Inizia a disegnare';
      }
    } else {
      return 'Ricerca';
    }
  }

  handleClick(): void {
    if (!this.mobile || this.metodo !== 4) {
      this.closeWithResults();
    } else {
      if (!this.isFreeHandEditing) {
        this.startFreeHandDrawing();
      } else {
        if (this.hasFinishedFreeHandEditing) {
          this.closeWithResults();
        }
      }
    }
  }

  startFreeHandDrawing(): void {
    this.drawPolygon.setMode('add');
    this.isFreeHandEditing = true;
  }

  // MODE SELECTORS

  changeMode(modeIdentifier: number): void {
    if (modeIdentifier !== this.metodo) {
      this.untouched = false;
      this.resetSelection();
      this.map.off();
      this.map.remove();
      this.map = undefined;
      this.showMap = false;
      this.metodo = modeIdentifier;
      this.changeEvent.emit(modeIdentifier);
      setTimeout(() => {
        this.showMap = true;
      }, 1);
      setTimeout(() => {
        this.initFunction(true);
      }, 10);
      this.citySelected = undefined;
      this.isCityWithZone = undefined;
      if (this.cityPerimeter) {
        this.cityPerimeter.clearLayers();
      }
    }
  }

  // RANGE SLIDER
  onSliderChange(): void {
    const circle = this.circle;
    const radius = this.rangeValue * 1000;

    this.resetSelection();
    circle.setRadius(radius);
    circle.editing.enable();
    const geoJson = circle.toGeoJSON();
    geoJson.properties.radius = circle.getRadius();
    this.selectedFeatures.push(geoJson);
    if (!this.shownLayers) {
      this.shownLayers = new this.L.FeatureGroup();
    }
    this.shownLayers.addLayer(circle);
    this.map.addLayer(this.shownLayers);
    this.createDeleteButton(circle.getLatLng(), circle._radius, 'circle');
    this.map.fitBounds(circle.getBounds());
    this.showRange = true;
    this.rangeValue = circle._mRadius / 1000;
    this.circle = circle;

    this.mapLoading = true;
    this.zones.zoneGeocode(circle.getLatLng().lat, circle.getLatLng().lng).subscribe(
      (success) => {
        this.mapLoading = false;
        try {
          this.comune = 'Zona non indetificata';
          success.features.forEach((item) => {
            if (item.id.toString().indexOf('region.') !== -1) {
              this.selectedFeatures[0].properties.prov_name = item.text;
            }
            if (item.id.toString().indexOf('place.') !== -1) {
              this.comune = item.text;
              this.selectedFeatures[0].properties.name = item.text;
            }
          });
          this.placeholder = (radius / 1000).toString() + ' km da ' + this.comune;
          this.map.off('click');
        } catch (e) {
          this.console.error(e);
          this.comune = 'Zona non indetificata';
          this.placeholder = this.comune;
        }
      },
      (error) => {
        this.mapLoading = false;
      }
    );
  }

  // ESTENDE L.CIRCLE EDIT e lo modoifica
  extendLCircle(): void {
    const that = this;
    this.L.Edit.Circle = this.L.Edit.Circle.extend({
      _createMoveMarker(): void {
        const center = this._shape.getLatLng();
        this._moveMarker = this._createMarker(center, this.options.moveIcon);
      },

      _createResizeMarker(): void {
        const center = this._shape.getLatLng();
        const resizemarkerPointN = this._getResizeMarkerPoint(center, 'n');
        const resizemarkerPointS = this._getResizeMarkerPoint(center, 's');
        const resizemarkerPointW = this._getResizeMarkerPoint(center, 'w');
        const resizemarkerPointE = this._getResizeMarkerPoint(center, 'e');

        this._resizeMarkers = [];
        this._resizeMarkers.push(this._createMarker(resizemarkerPointN, this.options.resizeIcon));
        this._resizeMarkers.push(this._createMarker(resizemarkerPointS, this.options.resizeIcon));
        this._resizeMarkers.push(this._createMarker(resizemarkerPointW, this.options.resizeIcon));
        this._resizeMarkers.push(this._createMarker(resizemarkerPointE, this.options.resizeIcon));
      },

      _getResizeMarkerPoint(latlng, nswe): any {
        // From L.shape.getBounds()
        const delta = this._shape._radius * Math.cos(Math.PI / 18);
        const point = this._map.project(latlng);

        switch (nswe) {
          case 'n': {
            return this._map.unproject([point.x, point.y - delta * 1.03]);
          }
          case 's': {
            return this._map.unproject([point.x, point.y + delta]);
          }
          case 'w': {
            return this._map.unproject([point.x - delta * 1.03, point.y]);
          }
          case 'e': {
            return this._map.unproject([point.x + delta, point.y]);
          }
        }
      },

      _move(latlng): void {
        const resizemarkerPointN = this._getResizeMarkerPoint(latlng, 'n');
        const resizemarkerPointS = this._getResizeMarkerPoint(latlng, 's');
        const resizemarkerPointW = this._getResizeMarkerPoint(latlng, 'w');
        const resizemarkerPointE = this._getResizeMarkerPoint(latlng, 'e');

        // Move the resize marker
        this._resizeMarkers[0].setLatLng(resizemarkerPointN);
        this._resizeMarkers[1].setLatLng(resizemarkerPointS);
        this._resizeMarkers[2].setLatLng(resizemarkerPointW);
        this._resizeMarkers[3].setLatLng(resizemarkerPointE);

        // Move the circle
        this._shape.setLatLng(latlng);
        if (!that.mobile) {
          document.addEventListener('mouseup', () => {
            this._map.fire(that.L.Draw.Event.EDITMOVE, { layer: this._shape });
          }, { once: true });
        } else {
          document.addEventListener('touchend', () => {
            this._map.fire(that.L.Draw.Event.EDITMOVE, { layer: this._shape });
          }, { once: true });
        }
      },

      _resize(latlng): void {
        const moveLatLng = this._moveMarker.getLatLng();
        const radius = moveLatLng.distanceTo(latlng);
        this._shape.setRadius(radius);
        this._move(moveLatLng);
        this._map.fire(that.L.Draw.Event.EDITRESIZE, { layer: this._shape });
      }
    });
  }

  // TROVA POSIZIONE SU MAPPA A 1/2 e 1/4 TRA DUE PUNTI
  findHalfLatLng(latLngA, latLngB): {} {
    function toRadians(degress: number): number {
      return degress * (Math.PI / 180);
    }

    function toDegrees(radians: number): string {
      return (radians * (180 / Math.PI)).toFixed(4);
    }

    const lngDiff = toRadians(latLngB.lng - latLngA.lng);
    const latA = toRadians(latLngA.lat);
    const latB = toRadians(latLngB.lat);
    const lngA = toRadians(latLngA.lng);

    const bx = Math.cos(latB) * Math.cos(lngDiff);
    const by = Math.cos(latB) * Math.sin(lngDiff);

    const latMidway = toDegrees(
      Math.atan2(
        Math.sin(latA) + Math.sin(latB),
        Math.sqrt((Math.cos(latA) + bx) * (Math.cos(latA) + bx) + by * by)
      )
    );
    const lngMidway = toDegrees(lngA + Math.atan2(by, Math.cos(latA) + bx));

    return { lat: latMidway, lng: lngMidway };
  }

  findQuarterLatLng(latLngA, latLngB): {} {
    const firstHalf = this.findHalfLatLng(latLngA, latLngB);
    return this.findHalfLatLng(latLngA, firstHalf);
  }

  // Delete button
  createDeleteButton(latLng, radius, type: string): void {
    const that = this;
    let deleteButton: any;
    if (type === 'circle') {
      const delta = radius * Math.cos(Math.PI / 4);
      const point = this.map.project(latLng);
      const ne = this.map.unproject([point.x + delta, point.y - delta]);
      deleteButton = this.L.marker(
        ne,
        {
          icon: new this.L.Icon({
            iconUrl: '../assets/img/map-close.png',
            iconSize: [30, 30],
          })
        }
      ).on('click', (e: any) => {
        that.resetSelection();
      });
    } else {
      let iconSize;
      if (type === 'pointMobile') {
        iconSize = [40, 40];
      } else {
        iconSize = [30, 30];
      }
      deleteButton = this.L.marker(
        latLng,
        {
          icon: new this.L.Icon({
            iconUrl: '../assets/img/map-close.png',
            iconSize,
          }),
        }
      ).on('click', (e: any) => {
        that.resetSelection(true);
      });
    }
    deleteButton.setZIndexOffset(999);
    this.deleteLayer = new this.L.FeatureGroup();
    this.deleteLayer.addLayer(deleteButton);
    this.map.addLayer(this.deleteLayer);
  }

  destroyDeleteButton(): void {
    if (this.deleteLayer !== undefined) {
      this.map.removeLayer(this.deleteLayer);
    }
  }

  // MOSTRA ZONE COMUNE
  showZones(): any[] {
    let cityZones: any[];
    if (this.citySelected) {
      cityZones = this.citySelected.children.filter(z => z.type === 'Zona');
      return cityZones.sort((a, b) => {
        if (a.display_name < b.display_name) { return -1; }
        if (a.display_name > b.display_name) { return 1; }
        return 0;
      });
    } else {
      return [];
    }
  }

  async selectAllCityZones(e: Event): Promise<void> {
    const citySelected = this.citySelected;
    let toggleShowCityZones: boolean;
    if (this.selectedFeatures.filter(a => (a.properties.comune_name !== this.citySelected.name) && (a.properties.type === 'Zona')).length === 0) {
      toggleShowCityZones = true;
    }
    const target = e.target as HTMLInputElement;
    target.checked = true;
    this.selectedFeatures = this.selectedFeatures.filter(a => a.properties.comune_name !== this.citySelected.name);
    this.isCityWithZone = undefined;
    this.citySelected = undefined;
    await this.clickSearchItem(citySelected, false);
    this.isCityWithZone = true;
    this.citySelected = citySelected;
    if (toggleShowCityZones) {
      this.showCityZones = !this.showCityZones;
    }
  }

  clickOnCityZone(zoneName: string): void {
    const polygon = this.shownLayers.getLayers()?.filter(a => {
      return a.getLayers()[0]?.feature?.name === zoneName;
    })[0];
    const layer = polygon.getLayers()[0];
    const feature = layer.feature;
    this.clickOnPolygon(feature, polygon, layer);
    if (this.checkNoZoneSelected()) {
      this.resetCitySelected();
      this.isCityWithZone = undefined;
    }
    this.redrawPolygons();
    if (this.citySelected?.geometry) {
      this.map.fitBounds(this.L.geoJson(this.citySelected.geometry).getBounds());
    }
  }

  checkSelectedZones(zoneName: string): boolean {
    const index = this.selectedFeatures.findIndex(a => a.name === zoneName);
    return index > -1;
  }

  checkNoZoneSelected(): boolean {
    let index;
    this.selectedFeatures.forEach(feature => {
      index = this.citySelected.children.findIndex(a => a.name === feature.name);
    });
    return index <= -1;
  }

  resetCitySelected(): void {
    if (this.selectedFeatures.length > 1) {
      const toRemove = this.selectedFeatures.filter(a => a.properties.comune_name === this.citySelected.name);
      toRemove.forEach(removal => {
        this.clickOnPolygon(removal, removal.polygon, removal.polygon.getLayers()[0]);
      });
      this.redrawPolygons();
    } else {
      this.resetSelection();
    }
    this.citySelected = undefined;
    this.isCityWithZone = undefined;
    if (this.cityPerimeter) {
      this.cityPerimeter.clearLayers();
    }
  }

  selectedFeaturesWithoutChildren(): any[] {
    return this.selectedFeatures.filter(a => a.properties.comune_name !== this.citySelected.name);
  }

  countChildrensSelected(): number {
    return this.selectedFeatures.filter(a => a.properties.comune_name === this.citySelected.name && a.properties.name !== this.citySelected.name).length;
  }

  async addCityPerimeterToMap(): Promise<void> {
    const geoJSON = await this.L.geoJson(this.citySelected.geometry, {
      color: '#166FC1',
      weight: 5,
      opacity: 1,
      fillOpacity: 0,
      lineCap: 'round',
      linejoin: 'round',
      fillColor: '#166FC1',
      fillRule: 'evenodd',
      interactive: false,
    });

    // this.map.fitBounds(geoJSON.getBounds());

    if (this.cityPerimeter) {
      this.cityPerimeter.clearLayers();
    } else {
      this.cityPerimeter = new this.L.FeatureGroup();
    }
    this.cityPerimeter.addLayer(geoJSON);
    this.map.addLayer(this.cityPerimeter);
  }

  toggleMobileZones(): void {
    this.showMobileCityList = !this.showMobileCityList;
    if (this.showMobileCityList) {
      this.document.documentElement.style.height = '100%';
      this.document.documentElement.style.position = 'fixed';
    } else {
      this.document.documentElement.style.height = 'unset';
      this.document.documentElement.style.position = 'unset';
    }
  }
}
